export default __webpack_public_path__ + "static/11-954e411430efe5365eea7292e245d9bc.jpg";